export const CYBER_ASSESSMENT_TITLE = 'Cyber Assessment';
